import {CompanyData} from "./company-data.model";
import { IPublicProfile } from "./public-profile.model";
import { FeatureFlags } from "./feature-flags.model";

export interface AccountStatus {
  userType:AccountUserType,
  level: AccountLevel,
  kycStatus: string,
  companyStatus: string,
  limitCurrent: number,
  limitUsed: number,
  score: AccountScore,
  userBalance:UserBalance,
  companyData:AccountCompanyData,
  nickname:string,
  dateAdditionalDocument:boolean
  disabled: string;
  verificationStatus:VerificationStatus;
  cantidadHorasVtoOferta: number;
  inversorStatus: string;
  financialStatus: string;
  procentajeComisionFinanciamiento: number;
  faltaCargarCBU: boolean;
  /** Opcional: flags enviados por el backend. Ver feature-flags.model.ts */
  featureFlags?: Partial<FeatureFlags>;
}
export interface AccountScore {
  scoreBuroCrediticio: string,
  scoreApp: string,
  scoreTecnico: string,
  score: string
}
export interface AccountLevel {
  deletedDate: any;//"2022-10-19T19:37:40.600Z",
  id: string,
  description: string,
  percentComplete: number,
  defaultLimit: number
}
export interface AccountUserType {
  description:string,
  id:string
}
export interface UserBalance {
  balance:number,
  balanceLocked:number,
  available:number
}
interface AccountCompanyData {
  name:string,
  idNumber:string
}
export interface VerificationStatus {
  email:string//
  documentos?:string, //SOLO para PJ
  id:number, // id del usuario
  informacionAdicional:string; //google forms
  kyc:string; //metamap
}

export enum InvestorProfiles {
  accepted = 'ACEPTADO',
  rejected = 'RECHAZADO',
  notSolicited = 'NO_SOLICITADO',
  pendingAuth = 'PENDIENTE_BO',
  pendingSign = 'PENDIENTE_FIRMA'
}

export enum FinancialStatus {
  DENIED_FOR_REQUEST = 'DENIED_FOR_REQUEST',
  ENABLED_FOR_REQUEST = 'ENABLED_FOR_REQUEST',
  NO_DATA = 'NO_DATA',
  NO_DOCUMENTATION = 'NO_DOCUMENTATION'
  // pendingAuth = 'PENDING_BO',
  // approved = 'APPROVED_BO',
  // pendingFunding = 'PENDING_FUNDING',
  // financed = 'FINANCED'
}